/**
 * Created by Victor Rojo on 5/10/18.
 */
import {Component, Input, ViewChild, TemplateRef, ViewContainerRef} from '@angular/core';
import {Widget, WidgetTypes, StatusLevels} from "../../widget/Widget";
import {WidgetService} from "../../widget/Widget.service";
import {Globals} from '../../../globals';

@Component({
  selector: 'widget-status-icon',
  templateUrl: './WidgetStatusIcon.component.html',
  styleUrls: ['./WidgetStatusIcon.component.css']
})
export class WidgetStatusIconComponent {
  private _widget: Widget;
  private maintenanceModeId: number;
  private currencySymbol = '€';
  @ViewChild("icon", { read: ViewContainerRef, static: true }) iconView: ViewContainerRef;
  @ViewChild('tankIcon', { static: true }) tankIconTemplate: TemplateRef<any>;
  @ViewChild('pumpIcon', { static: true }) pumpIconTemplate: TemplateRef<any>;
  @ViewChild('pricePoleIcon', { static: true }) pricePoleIconTemplate: TemplateRef<any>;

  constructor(private widgetService: WidgetService, private globals: Globals) {
    this.maintenanceModeId = StatusLevels.MAINTENANCE;
    this.setCurrencySymbol();
  }

  private setCurrencySymbol() {
    if (this.globals.tenant === 'ecuador') {
      this.currencySymbol = '$';
    }
  }

  get widget(): Widget {
    return this._widget;
  }

  @Input()
  set widget(widget: Widget) {
    this._widget = widget;
    this.updateSVGIcon();
  }

  updateSVGIcon(){
    if ( this._widget.widgetTypeId == WidgetTypes.TANK) {
      let view = this.tankIconTemplate.createEmbeddedView(null);
      this.iconView.insert(view);
    } else if ( this._widget.widgetTypeId == WidgetTypes.PUMP) {
      let view = this.pumpIconTemplate.createEmbeddedView(null);
      this.iconView.insert(view);
    } else if ( this._widget.widgetTypeId == WidgetTypes.PRICE_POLE) {
      let view = this.pricePoleIconTemplate.createEmbeddedView(null);
      this.iconView.insert(view);
    }
  }

  getStatusLevelClass(statusLevelId:number){
    let klass = "";
    if ( statusLevelId == StatusLevels.OK ){
      klass = "status-ok";
    } else if ( statusLevelId == StatusLevels.WARNING ) {
      klass = "status-warning";
    } else if ( statusLevelId == StatusLevels.ERROR ){
      klass = "status-error";
    } else if ( statusLevelId == StatusLevels.MAINTENANCE ){
      klass = "status-maintenance";
    }
    return klass;
  }

  setMaintenanceMode(active:boolean) {
    this.widgetService.setMaintenanceMode(this._widget.widgetId, active);
  }
}
